<script>
  /** @type {string | null} */
  export let message = null
  /** @type {string | null} */
  export let description = null
  export let isHtmlMessage = false
  /** @type {"success" | "warning" | "error"} */
  export let type = "success"
  /** @type {"flat" | "default"} */
  export let variant = "default"
  export let animate = true

  import { createEventDispatcher } from "svelte"
  import { draw, fade } from "svelte/transition"

  import { slideIn } from "../../transitions/slide-in"

  const dispatch = createEventDispatcher()

  function handleDismisss() {
    dispatch("dismiss")
  }

  /**
   * @param {Element} node
   * @param {{ dismissible: boolean }} arg
   */
  function animateFn(node, arg) {
    if (arg.dismissible) {
      return slideIn(node, { inFrom: "right", duration: 300 })
    }
    return fade(node)
  }
</script>

{#if animate}
  <div
    transition:animateFn|local={{ dismissible: variant === "default" }}
    class="percs-alert percs-alert--type-{type}"
    class:percs-alert--variant-dismissable={variant === "default"}
    class:percs-alert--variant-flat={variant === "flat" }
  >
    <div class="percs-alert__container">
      <div class="percs-alert__icon-container">
        {#if type === "success"}
          <!-- Heroicon name: heroicons-outline/check-circle -->
          <svg class="percs-alert__icon text-green-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path transition:draw|local={{ duration: 400 }} stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        {:else if type === "warning"}
          <!-- Heroicon name: solid/exclamation -->
          <svg class="percs-alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
        {:else}
          <!-- Heroicon name: heroicons-outline/x-circle -->
          <svg class="percs-alert__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path transition:draw|local={{ duration: 400 }} d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        {/if}
      </div>
      <div class="percs-alert__content">
        <slot>
          {#if message}
            {#if isHtmlMessage}
              <p class="text-sm font-medium text-gray-900">{@html message}</p>
            {:else}
              <p class="text-sm font-medium text-gray-900">{message}</p>
            {/if}
          {/if}
          {#if description}
            {#if isHtmlMessage}
              <p class="mt-1 text-sm text-gray-500">{@html description}</p>
            {:else}
              <p class="mt-1 text-sm text-gray-500">{description}</p>
            {/if}
          {/if}
        </slot>
      </div>
      {#if variant === "default"}
        <div class="percs-alert__close-icon-container">
          <button
            type="button"
            on:click={handleDismisss}
            class="percs-alert__close-icon-button focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">Close</span>
            <!-- heroicon name: heroicons-outline/x-mark -->
            <svg class="percs-alert__close-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path transition:draw|local={{ duration: 400 }} d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"></path>
            </svg>
          </button>
        </div>
      {/if}
    </div>
  </div>
{:else}
  <div
    class="percs-alert percs-alert--type-{type}"
    class:percs-alert--variant-dismissable={variant === "default"}
    class:percs-alert--variant-flat={variant === "flat" }
  >
    <div class="percs-alert__container">
      <div class="percs-alert__icon-container">
        {#if type === "success"}
          <!-- Heroicon name: heroicons-outline/check-circle -->
          <svg class="percs-alert__icon text-green-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        {:else if type === "warning"}
          <!-- Heroicon name: solid/exclamation -->
          <svg class="percs-alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
        {:else}
          <!-- Heroicon name: heroicons-outline/x-circle -->
          <svg class="percs-alert__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        {/if}
      </div>
      <div class="percs-alert__content">
        <slot>
          {#if message}
            {#if isHtmlMessage}
              <p class="text-sm font-medium text-gray-900">{@html message}</p>
            {:else}
              <p class="text-sm font-medium text-gray-900">{message}</p>
            {/if}
          {/if}
          {#if description}
            {#if isHtmlMessage}
              <p class="mt-1 text-sm text-gray-500">{@html description}</p>
            {:else}
              <p class="mt-1 text-sm text-gray-500">{description}</p>
            {/if}
          {/if}
        </slot>
      </div>
      {#if variant === "default"}
        <div class="percs-alert__close-icon-container">
          <button
            type="button"
            on:click={handleDismisss}
            class="percs-alert__close-icon-button focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">Close</span>
            <!-- heroicon name: heroicons-outline/x-mark -->
            <svg class="percs-alert__close-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path transition:draw|local={{ duration: 400 }} d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"></path>
            </svg>
          </button>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  :global(.percs-alert) {
    width: 100%;
    background-color: white;
    pointer-events: auto;
    padding: 1rem;
  }

  :global(.percs-alert--variant-dismissable) {
    /* @apply ring-1 ring-black ring-opacity-5; */
    border-radius: 0.5rem;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    overflow: hidden;
    max-width: 24rem;
  }

  :global(.percs-alert--variant-flat) {
    border-radius: 0.375rem;
  }

  :global(.percs-alert__container) {
    display: flex;
    align-items: flex-start;
  }

  :global(.percs-alert__icon-container) {
    flex-shrink: 0;
  }

  :global(.percs-alert__icon) {
    height: 1.25rem;
    width: 1.25rem;
  }

  :global(.percs-alert--type-warning .percs-alert__icon) {
    --tw-text-opacity: 1;
    color: rgb(234 179 8 / var(--tw-text-opacity));
  }

  :global(.percs-alert__content) {
    flex: 1 1 0%;
    width: 0px;
    margin-left: 0.75rem;
    padding-top: 0.125rem;
  }

  :global(.percs-alert__close-icon-container) {
    margin-left: 1rem;
    display: flex;
    flex-shrink: 0;
  }

  :global(.percs-alert__close-icon-button) {
    cursor: pointer;
    display: inline-flex;
    background-color: white;
    color: rgb(156 163 175);
    position: relative;
    display: flex;
    border-radius: 0.375rem;
    outline: none;
    border: none;
  }

  :global(.percs-alert__close-icon-button:hover) {
    color: rgb(107 114 128);
  }

  :global(.percs-alert__close-icon) {
    height: 1.25rem;
    width: 1.25rem;
  }

  :global(.sr-only) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>
